import { getFontStyle } from '@diversioteam/diversio-ds'
import styled from 'styled-components'

export const Container = styled.section`
    height: 100%;
    padding: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
        margin-top: 48px;
    }
`

export const Info = styled.article`
    min-width: 800px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    border-radius: 15px;
    background-color: ${({ theme }) => theme.colors.primaryWhite};
    box-shadow: 6px 12px 30px 0px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;

    &:before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 8px;
        background-color: ${({ theme }) => theme.colors.primary40};
    }
`

export const Title = styled.h2`
    margin: 0 0 18px;
    color: ${({ theme }) => theme.colors.primary90};

    ${getFontStyle('h2Bold')}
`

export const Description = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.colors.secondary500};
    white-space: pre-wrap;

    ${getFontStyle('p01Regular')}
`
